
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Body Row Event Custom" fileName="on-body-row.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        Open F12 to view the console information
        &lt;ve-table
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :event-custom-option=&quot;eventCustomOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                eventCustomOption: {
                    bodyRowEvents: ({ row, rowIndex }) =&gt; {
                        return {
                            click: (event) =&gt; {
                                console.log(&quot;click::&quot;, row, rowIndex, event);
                            },
                            dblclick: (event) =&gt; {
                                console.log(&quot;dblclick::&quot;, row, rowIndex, event);
                            },
                            contextmenu: (event) =&gt; {
                                console.log(&quot;contextmenu::&quot;, row, rowIndex, event);
                            },
                            mouseenter: (event) =&gt; {
                                console.log(&quot;mouseenter::&quot;, row, rowIndex, event);
                            },
                            mouseleave: (event) =&gt; {
                                console.log(&quot;mouseleave::&quot;, row, rowIndex, event);
                            },
                        };
                    },
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [
                    {
                        rowKey: 1001,
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        rowKey: 1002,
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        rowKey: 1003,
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        rowKey: 1004,
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        rowKey: 1005,
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_vm._v("\n        Open F12 to view the console information\n        "),_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"event-custom-option":_vm.eventCustomOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                eventCustomOption: {
                    bodyRowEvents: ({ row, rowIndex }) => {
                        return {
                            click: (event) => {
                                console.log("click::", row, rowIndex, event);
                            },
                            dblclick: (event) => {
                                console.log("dblclick::", row, rowIndex, event);
                            },
                            contextmenu: (event) => {
                                console.log("contextmenu::", row, rowIndex, event);
                            },
                            mouseenter: (event) => {
                                console.log("mouseenter::", row, rowIndex, event);
                            },
                            mouseleave: (event) => {
                                console.log("mouseleave::", row, rowIndex, event);
                            },
                        };
                    },
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 50,
                        align: "center",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [
                    {
                        rowKey: 1001,
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        rowKey: 1002,
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        rowKey: 1003,
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        rowKey: 1004,
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        rowKey: 1005,
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  